export const AI_SHORTCUTS = [
    // --- Generic Actions ---
    {
      title: "Summarize content",
      prompt: "Provide the key points and concepts in this content in a succinct summary.",
      selection: true
    },
    {
      title: "Improve writing",
      prompt: "Rewrite this content with no spelling mistakes, proper grammar, and more descriptive language, using best writing practices without losing the original meaning.",
      selection: true
    },
    {
      title: "Simplify language",
      prompt: "Rewrite this content with simplified language and reduce the complexity of the writing so it’s easier to understand.",
      selection: true
    },
    {
      title: "Expand upon",
      prompt: "Expand upon this content with descriptive language and more detailed explanations to increase clarity and length.",
      selection: true
    },
    {
      title: "Trim content",
      prompt: "Remove any repetitive, redundant, or non‑essential writing in this content without changing the meaning or losing key information.",
      selection: true
    },
  
    // --- Change Tone ---
    {
      title: "Change tone",
      subprompts: [
        {
          title: "Professional",
          prompt: "Rewrite this content using polished, formal, and respectful language to convey professional expertise and competence.",
          selection: true
        },
        {
          title: "Casual",
          prompt: "Rewrite this content with casual, informal language to sound like a friendly conversation.",
          selection: true
        },
        {
          title: "Direct",
          prompt: "Rewrite this content with direct language using only the essential information.",
          selection: true
        },
        {
          title: "Confident",
          prompt: "Rewrite this content using compelling, optimistic language to convey confidence.",
          selection: true
        },
        {
          title: "Friendly",
          prompt: "Rewrite this content using warm, empathetic language to convey understanding and support.",
          selection: true
        }
      ]
    },
  
    // --- Change Style (minus legal & poetic) ---
    {
      title: "Change style",
      subprompts: [
        {
          title: "Business",
          prompt: "Rewrite this content as a business professional with formal, clear language.",
          selection: true
        },
        {
          title: "Journalism",
          prompt: "Rewrite this content as a journalist using engaging language to highlight its importance.",
          selection: true
        },
        {
          title: "Medical",
          prompt: "Rewrite this content as a medical professional using accurate medical terminology.",
          selection: true
        }
      ]
    },
  
    // --- Translate ---
    {
      title: "Translate",
      subprompts: [
        { title: "To English",            prompt: "Translate this content to English.",             selection: true },
        { title: "To Spanish",            prompt: "Translate this content to Spanish.",             selection: true },
        { title: "To Portuguese",         prompt: "Translate this content to Portuguese.",          selection: true },
        { title: "To German",             prompt: "Translate this content to German.",              selection: true },
        { title: "To French",             prompt: "Translate this content to French.",              selection: true },
        { title: "To Norwegian",          prompt: "Translate this content to Norwegian.",           selection: true },
        { title: "To Ukrainian",          prompt: "Translate this content to Ukrainian.",           selection: true },
        { title: "To Japanese",           prompt: "Translate this content to Japanese.",            selection: true },
        { title: "To Korean",             prompt: "Translate this content to Korean.",              selection: true },
        { title: "To Simplified Chinese", prompt: "Translate this content to Simplified Chinese.",  selection: true },
        { title: "To Hebrew",             prompt: "Translate this content to Hebrew.",              selection: true },
        { title: "To Hindi",              prompt: "Translate this content to Hindi.",               selection: true },
        { title: "To Arabic",             prompt: "Translate this content to Arabic.",              selection: true }
      ]
    }
  ];
  